import React from 'react';
import ScopeBadge from './ScopeBadge';
import { formatDateTime, statusColorClass } from '../lib/openPlatformFormatters';

const ApiClientTable = ({ items = [], onRotateKey, onRevoke, onCreate }) => (
  <div className="rounded-lg border border-slate-800 bg-slate-900/70">
    <div className="flex items-center justify-between border-b border-slate-800 px-3 py-2">
      <h3 className="text-sm font-semibold text-slate-100">API Clients</h3>
      <button type="button" onClick={onCreate} className="rounded border border-cyan-400/40 bg-cyan-500/10 px-2 py-1 text-xs font-semibold text-cyan-200">
        Buat Client
      </button>
    </div>
    <div className="overflow-x-auto">
      <table className="min-w-full text-xs">
        <thead className="bg-slate-950/80 text-slate-400">
          <tr>
            <th className="px-3 py-2 text-left">Client</th>
            <th className="px-3 py-2 text-left">Scopes</th>
            <th className="px-3 py-2 text-left">Status</th>
            <th className="px-3 py-2 text-left">Created</th>
            <th className="px-3 py-2 text-left">Last Used</th>
            <th className="px-3 py-2 text-left">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.clientId} className="border-t border-slate-800 text-slate-200">
              <td className="px-3 py-2">
                <p className="font-semibold text-slate-100">{item.name}</p>
                <p className="text-[11px] text-slate-500">{item.clientId}</p>
              </td>
              <td className="px-3 py-2">
                <div className="flex flex-wrap gap-1">
                  {(item.scopes || []).map((scope) => <ScopeBadge key={scope} scope={scope} />)}
                </div>
              </td>
              <td className="px-3 py-2">
                <span className={`inline-flex rounded border px-2 py-0.5 text-[11px] font-semibold ${statusColorClass(item.status)}`}>
                  {String(item.status || '').toUpperCase()}
                </span>
              </td>
              <td className="px-3 py-2">{formatDateTime(item.createdAt)}</td>
              <td className="px-3 py-2">{formatDateTime(item.lastUsedAt)}</td>
              <td className="px-3 py-2">
                <div className="flex gap-2">
                  <button type="button" onClick={() => onRotateKey(item.clientId)} className="rounded border border-amber-400/40 bg-amber-500/10 px-2 py-1 text-[11px] text-amber-200">
                    Rotate Key
                  </button>
                  <button type="button" onClick={() => onRevoke(item.clientId)} className="rounded border border-red-400/40 bg-red-500/10 px-2 py-1 text-[11px] text-red-200">
                    Revoke
                  </button>
                </div>
              </td>
            </tr>
          ))}
          {items.length === 0 ? (
            <tr>
              <td colSpan={6} className="px-3 py-6 text-center text-slate-500">Belum ada API client.</td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  </div>
);

export default ApiClientTable;
